export default "/credits/business/assets/dd6bcf4b91362109a06076a4971e67f0.png";